<template>
  <div class="datetime-container" :class="{ error: error }">
    <Datepicker
      class="input-datetime"
      locale="ja"
      week-start="0"
      v-model="datetime"
      :format="datetimeFormat"
      :minutesIncrement="minutesUpDown"
      :minutesGridIncrement="minutesUpDown"
      :startTime="startTime"
      :day-class="getDayClass"
      :textInput="isTextInput"
      :disabled="isDisabled"
      :clearable="isClearable"
    />
    <p class="input-error" v-if="error">{{ error }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useConfigStore } from '@/store/config'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default defineComponent({
  setup(props, context) {
    const configStore = useConfigStore()

    const datetime = computed({
      get() {
        return props.modelValue
      },
      set(val) {
        if (val && typeof val === 'object') {
          context.emit('update:modelValue', (val as Date).toLocaleString('ja-JP'));
        } else {
          context.emit('update:modelValue', val);
        }
      }
    })
    const datetimeFormat = ref('yyyy/MM/dd HH:mm')

    const minutesUpDown = computed(() => {
      if (typeof props.minutesIncrement === 'undefined' || typeof props.minutesIncrement !== 'number') {
        return configStore.dakokuRound
      }
      return props.minutesIncrement
    })

    const isClearable = computed(() => {
      if (typeof props.clearable === 'undefined' || typeof props.clearable !== 'boolean') {
        // props未指定時
        return true
      }
      return props.clearable
    })

    const isTextInput = computed(() => {
      if (typeof props.textInput === 'undefined' || typeof props.textInput !== 'boolean') {
        // props未指定時
        return true
      }
      return props.textInput
    })

    const isDisabled = computed(() => {
      if (typeof props.disabled === 'undefined' || typeof props.disabled !== 'boolean') {
        // props未指定時
        return false
      }
      return props.disabled
    })

    const getDayClass = (date: Date) => {
      const weekDay = date.getDay()
      if (weekDay == 6) {
        // 土曜日の場合、classに"saturday"を追加
        return 'saturday'
      } else if (weekDay == 0) {
        // 日曜日の場合、classに"sunday"を追加
        return 'sunday'
      }
      return ''
    }

    return {
      datetime,
      datetimeFormat,
      minutesUpDown,
      isClearable,
      isTextInput,
      isDisabled,
      getDayClass
    }
  },
  props: ['modelValue', 'clearable', 'error', 'textInput', 'disabled', 'minutesIncrement', 'startTime'],
  emits: ['update:modelValue'],
  components: {
    Datepicker
  }
})
</script>

<style>
/* scopedの中には書かない */
.saturday {
  color: #0000ff;
}

.sunday {
  color: #ff0000;
}
</style>
